import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgAllCoursesIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17 14.5v-3.0056c0-.1794 0-.2692-.0273-.3484a.5.5 0 0 0-.1155-.1868c-.0586-.0599-.1389-.1-.2994-.1803L12 8.5m-8 1v6.8066c0 .3719 0 .5579.058.7207.0513.1439.1349.2742.2444.3808.1238.1206.2929.1981.631.353l6.4 2.9334c.2452.1124.3678.1686.4955.1907a1 1 0 0 0 .3422 0c.1277-.0221.2503-.0783.4955-.1907l6.4-2.9334c.3381-.1549.5072-.2324.631-.353a1 1 0 0 0 .2444-.3808c.058-.1628.058-.3488.058-.7207V9.5m-18-1 9.6422-4.8211c.1312-.0656.1968-.0984.2656-.1113a.5.5 0 0 1 .1844 0c.0688.0129.1344.0457.2656.1113L22 8.5l-9.6422 4.8211c-.1312.0656-.1968.0984-.2656.1113a.5.5 0 0 1-.1844 0c-.0688-.0129-.1344-.0457-.2656-.1113z"
    />
  </svg>
);
export default SvgAllCoursesIcon;
